import { AfterViewInit, Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { BooleanConverter, InputConverter, JSONConverter, NumberConverter } from '../../../inputConverter';
import { IMCNotification, LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-application-messages',
    styleUrls: ['../../sharedStyles/base.scss', './application-messages.component.scss'],
    templateUrl: './application-messages.component.html'
})
export class ApplicationMessagesComponent extends BaseComponent implements AfterViewInit {
    @Input()
    @InputConverter(JSONConverter)
    notificationLevels: number[] = [LogLevel.Info, LogLevel.Warn, LogLevel.Error];

    @Input()
    @InputConverter(BooleanConverter)
    showPrivate = false;

    @Input()
    @InputConverter(NumberConverter)
    durationInMs = 5000;

    @Input()
    activeNotifications: IMCNotification[] = [];

    uniqueMessageId = 0;
    spliceCount = 1;

    constructor(_vcr: ViewContainerRef) { super(_vcr, true); }

    async ngAfterViewInit() {
        window.addEventListener('applicationMessage', (notification: CustomEvent) => {
            const detail = notification.detail as IMCNotification;
            if (this.showPrivate && this.notificationLevels.includes(detail.level)) {
                this.addMessageToList(detail);
            } else if (!detail.isPrivate && this.notificationLevels.includes(detail.level)) {
                this.addMessageToList(detail);
            }
        });
    }

    addMessageToList(detail: IMCNotification) {
        detail.message = detail.level === LogLevel.Fatal ? 'A fatal error has occurred, please refresh application.' : detail.message;
        detail.uniqueId = this.uniqueMessageId;
        this.uniqueMessageId++;
        if (detail.level <= LogLevel.Debug) {
            detail.alertClass = 'alert';
        }
        if (detail.level === LogLevel.Info) {
            detail.alertClass = 'alert-green';
        }
        if (detail.level === LogLevel.Warn) {
            detail.alertClass = 'alert-yellow';
        }
        if (detail.level >= LogLevel.Error) {
            detail.alertClass = 'alert-red';
        }
        this.activeNotifications.push(detail);
        setTimeout(() => {
            const index = this.activeNotifications.findIndex(x => x.uniqueId === detail.uniqueId);
            this.activeNotifications.splice(index, this.spliceCount);
        }, this.durationInMs);
    }

    hideNotification(index: number) {
        this.activeNotifications.splice(index, this.spliceCount);
    }
}
